import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="dashboard">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 md:ml-64 min-h-[calc(100vh-64px)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
